  (function () {
    if (window.__hdtCouponPostMessageBridgeInit) return;
    window.__hdtCouponPostMessageBridgeInit = true;

  // Track processed messages to prevent infinite loops
  const processedMessages = new Set();
  let isProcessingMessage = false;

  // Create a unique message ID from the message data
  let messageCounter = 0;
  function getMessageId(data) {
    if (!data?.body) return null;
    const body = data.body;
    messageCounter++;
    // Use a combination of message data + counter for uniqueness
    return `${data.name}_${body.title}_${body.status}_${body.value}_${messageCounter}_${performance.now()}`;
  }

  function clearLegacyDiscountCartAttributes() {
    if (typeof window.clearDiscountCartAttributes === 'function') {
      return window.clearDiscountCartAttributes();
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          discount_code: '',
          discount_amount: '',
          discounted_total: '',
          discount_type: '',
          discount_applied: '',
        },
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to clear cart discount attributes');
        return response.json();
      })
      .catch(function (error) {
        console.error('Error clearing cart discount attributes:', error);
        return null;
      });
  }

  // Listen for postMessage events to update coupon drawer UI
  window.addEventListener('message', function (e) {

    // Create message ID for tracking
    const messageId = getMessageId(e.data);

    // Skip if this exact message was already processed
    if (messageId && processedMessages.has(messageId)) {
      console.log('Message already processed, skipping:', messageId);
      return;
    }

    // Skip if already processing to prevent infinite loops
    if (isProcessingMessage) {
      console.log('Already processing a message, skipping...');
      return;
    }

    // Handle coupon applied event
    if (e.data?.name === 'coupon_code_applied_sc' && e.data?.body) {
      const body = e.data.body;
      const couponCode = body.title || '';
      const discountValue = parseFloat(body.value) || 0;

      if (couponCode && body.status === 200) {
        if (typeof window.pushCouponAppliedToDataLayer === 'function') {
          window.pushCouponAppliedToDataLayer(couponCode);
        }
        if (typeof window.pushCouponSuccessToDataLayer === 'function') {
          window.pushCouponSuccessToDataLayer(couponCode);
        }
        // Mark message as processed and set processing flag BEFORE any operations
        if (messageId) {
          processedMessages.add(messageId);
          // Clean up old messages (keep only last 10)
          if (processedMessages.size > 10) {
            const first = processedMessages.values().next().value;
            processedMessages.delete(first);
          }
        }

        isProcessingMessage = true;
        console.log('Updating UI for applied coupon:', couponCode, 'Discount:', discountValue);

        // Update coupon button state in main DOM
        const couponCard = document.querySelector(`.coupon-card[data-coupon-code="${couponCode.toLowerCase()}"]`);
        if (couponCard) {
          const button = couponCard.querySelector('.cpnBtn');
          if (button) {
            button.innerHTML = 'Remove';
            // Keep 'cpnBtn' class, only remove 'cpnBtn-applied' if it exists
            button.classList.remove('cpnBtn-applied');
            // Ensure base class is present
            button.classList.add('cpnBtn');
            button.classList.add('cpnBtn-remove');
            button.setAttribute('data-code', couponCode);
            button.onclick = function () {
              if (window.removeCouponFn) {
                window.removeCouponFn(couponCode, this);
              }
            };
          }
        }

        // Update coupon button state in shadow DOM (side cart)
        const shadowDom = document.querySelector('shadow-dom-container')?.shadowRoot;
        if (shadowDom) {
          const shadowCouponCard = shadowDom.querySelector(
            `.coupon-card[data-coupon-code="${couponCode.toLowerCase()}"]`
          );
          if (shadowCouponCard) {
            const shadowButton = shadowCouponCard.querySelector('.cpnBtn');
            if (shadowButton) {
              shadowButton.innerHTML = 'Remove';
              // Keep 'cpnBtn' class, only remove 'cpnBtn-applied' if it exists
              shadowButton.classList.remove('cpnBtn-applied');
              // Ensure base class is present
              shadowButton.classList.add('cpnBtn');
              shadowButton.classList.add('cpnBtn-remove');
              shadowButton.setAttribute('data-code', couponCode);
              shadowButton.onclick = function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (window.removeCouponWithGokwikSync) {
                  window.removeCouponWithGokwikSync(couponCode, this);
                } else if (window.removeCouponFn) {
                  window.removeCouponFn(couponCode, this);
                }
              };
            }
          }
        }

        // Update discount display in subtotal
        const discountData = {
          total_discount: discountValue,
          total_price: 0, // Will be calculated from cart
          title: couponCode,
        };

        // Store discount info
        if (window.saveDiscountToStorage) {
          window.saveDiscountToStorage(discountData, couponCode);
        }

        // Checkout uses cookie only — never write discount_* cart attributes on apply.
        document.cookie = `discount_code=${couponCode}; path=/; max-age=${60 * 60 * 24 * 7}`;

        // Show discount in subtotal area (strip any legacy attributes first)
        if (window.showDiscountInSubtotal) {
          fetch('/cart.js')
            .then(function (response) {
              return response.json();
            })
            .then(function (cartData) {
              const cleanPromise =
                typeof window.ensureDiscountCartAttributesClean === 'function'
                  ? window.ensureDiscountCartAttributesClean(cartData)
                  : Promise.resolve(cartData);
              return cleanPromise.then(function (cleanedCart) {
                window.showDiscountInSubtotal(discountData, couponCode, cleanedCart || cartData);
              });
            })
            .catch(function (error) {
              console.error('Error fetching cart:', error);
              window.showDiscountInSubtotal(discountData, couponCode);
            });
        }

        // Update manual coupon input if exists
        if (window.forEachManualCouponRoot) {
          window.forEachManualCouponRoot(function (fields) {
          const manualInputField = fields.inputField;
          const manualCodeDisplay = fields.codeDisplay;
          const manualApplyBtn = fields.applyButton;

          if (manualInputField) {
            manualInputField.value = couponCode.toUpperCase();
            manualInputField.disabled = true;
          }

          if (manualCodeDisplay && manualApplyBtn) {
            manualCodeDisplay.textContent = couponCode.toUpperCase();
            manualCodeDisplay.style.display = 'inline-block';
            manualApplyBtn.innerHTML = 'Remove';
            manualApplyBtn.classList.add('cpnBtn-remove');
            manualApplyBtn.onclick = function () {
              if (window.removeManualCouponFn) {
                window.removeManualCouponFn(this);
              }
            };
          }
        });
        }

        // Reset processing flag after a delay
        setTimeout(() => {
          isProcessingMessage = false;
        }, 1000);
      }
    }

    // Handle coupon removed event
    if (e.data?.name === 'remove_applied_offer_sc' && e.data?.body) {
      const body = e.data.body;
      const couponCode = body.title || '';

      if (couponCode && body.status === 200) {
        if (typeof window.pushCouponRemovedToDataLayer === 'function') {
          window.pushCouponRemovedToDataLayer(couponCode);
        }
        // Mark message as processed and set processing flag BEFORE any operations
        const messageId = getMessageId(e.data);
        if (messageId) {
          processedMessages.add(messageId);
          // Clean up old messages (keep only last 10)
          if (processedMessages.size > 10) {
            const first = processedMessages.values().next().value;
            processedMessages.delete(first);
          }
        }

        isProcessingMessage = true;
        console.log('Updating UI for removed coupon:', couponCode);

        // Update coupon button state in main DOM
        const couponCard = document.querySelector(`.coupon-card[data-coupon-code="${couponCode.toLowerCase()}"]`);
        if (couponCard) {
          const button = couponCard.querySelector('.cpnBtn-remove, .cpnBtn');
          if (button) {
            button.innerHTML = 'Apply';
            button.classList.remove('cpnBtn-remove', 'cpnBtn-applied');
            button.classList.add('cpnBtn');
            button.setAttribute('data-code', couponCode);
            button.onclick = function () {
              if (window.applyCouponFn) {
                window.applyCouponFn(couponCode, this);
              }
            };
          }
        }

        // Update coupon button state in shadow DOM (side cart)
        const shadowDom = document.querySelector('shadow-dom-container')?.shadowRoot;
        if (shadowDom) {
          const shadowCouponCard = shadowDom.querySelector(
            `.coupon-card[data-coupon-code="${couponCode.toLowerCase()}"]`
          );
          if (shadowCouponCard) {
            const shadowButton = shadowCouponCard.querySelector('.cpnBtn-remove, .cpnBtn');
            if (shadowButton) {
              shadowButton.innerHTML = 'Apply';
              shadowButton.classList.remove('cpnBtn-remove', 'cpnBtn-applied');
              shadowButton.classList.add('cpnBtn');
              shadowButton.setAttribute('data-code', couponCode);
              shadowButton.onclick = function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (window.applyCouponWithGokwikSync) {
                  window.applyCouponWithGokwikSync(couponCode, this);
                } else if (window.applyCouponFn) {
                  window.applyCouponFn(couponCode, this);
                }
              };
            }
          }
        }

        // Remove discount row from subtotal
        const discountRow = document.querySelector('.applied-coupon-discount');
        if (discountRow) {
          discountRow.remove();
        }

        // Clear legacy discount_* cart attributes (checkout uses cookie only)
        clearLegacyDiscountCartAttributes()
          .then(function (updatedCart) {
            if (window.syncCartDrawerToPayFromShopifyCart) {
              window.syncCartDrawerToPayFromShopifyCart(updatedCart);
            }
          })
          .catch(function (error) {
            console.error('Error clearing cart discount attributes:', error);
            if (window.syncCartDrawerToPayFromShopifyCart) {
              window.syncCartDrawerToPayFromShopifyCart();
            }
          });

        // Clear cookie
        document.cookie = 'discount_code=; path=/; max-age=0';

        // Clear localStorage
        if (window.clearDiscountFromStorage) {
          window.clearDiscountFromStorage();
        }

        // Drop any GWP / free product cards tied to this coupon (side cart path)
        if (window.clearFreeProductsFromStorage) {
          window.clearFreeProductsFromStorage();
        }
        if (window.hideFreeProductsInCart) {
          window.hideFreeProductsInCart();
        }

        // Clear global reference
        if (window.appliedDiscount) {
          window.appliedDiscount = null;
        }

        // Update manual coupon input if exists
        if (window.forEachManualCouponRoot) {
          window.forEachManualCouponRoot(function (fields) {
          const manualInputField = fields.inputField;
          const manualCodeDisplay = fields.codeDisplay;
          const manualApplyBtn = fields.applyButton;

          if (manualInputField) {
            manualInputField.value = '';
            manualInputField.disabled = false;
          }

          if (manualCodeDisplay && manualApplyBtn) {
            manualCodeDisplay.style.display = 'none';
            manualCodeDisplay.textContent = '';
            manualApplyBtn.innerHTML = 'APPLY';
            manualApplyBtn.classList.remove('cpnBtn-remove');
            manualApplyBtn.onclick = function () {
              if (window.applyManualCouponFn) {
                window.applyManualCouponFn(this);
              }
            };
          }
        });
        }

        // Reset processing flag after a delay
        setTimeout(() => {
          isProcessingMessage = false;
        }, 1000);
      }
    }
  });
  })();
